import React, { ReactNode } from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { useEnvironment } from "../../../hooks/use-environment";
import { extractReactComponent } from "../../../utils/react/extract-react-component-from-svg-file";

const ZoomInIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/plus.svg").then(extractReactComponent);

const ZoomOutIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/minus.svg").then(extractReactComponent);

const SearchHereIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/search-here.svg").then(
    extractReactComponent,
  );

const SearchZoomIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/search-zoom.svg").then(
    extractReactComponent,
  );

const SegmentBirdingSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/segment-birding.svg").then(
    extractReactComponent,
  );
const SegmentOutdoorSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/segment-outdoor.svg").then(
    extractReactComponent,
  );
const SegmentHuntingSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/segment-hunting.svg").then(
    extractReactComponent,
  );

const SegmentBirdingTrimmedSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/segment-birding-trimmed.svg").then(
    extractReactComponent,
  );
const SegmentOutdoorTrimmedSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/segment-outdoor-trimmed.svg").then(
    extractReactComponent,
  );

const SegmentHuntingTrimmedSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/segment-hunting-trimmed.svg").then(
    extractReactComponent,
  );

const IconMyLocationSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/my-location-pin.svg").then(
    extractReactComponent,
  );

const PhoneIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/map-phone.svg").then(
    extractReactComponent,
  );
const MailIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/map-mail.svg").then(
    extractReactComponent,
  );

const NavigateIconSvg = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/dealer-locator/map-navigate.svg").then(
    extractReactComponent,
  );

const PingWhiteSvgIcon = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/icons/Icon/DKT/Meta/Pin White.svg").then(
    extractReactComponent,
  );

const AccountBlackSvgIcon = () =>
  import("!!@svgr/webpack?-svgo,+titleProp,+ref!../../../assets/icons/Icon/DKT/Meta/Account Black.svg").then(
    extractReactComponent,
  );

const Icons = {
  ZoomInIconSvg: React.lazy(ZoomInIconSvg),
  ZoomOutIconSvg: React.lazy(ZoomOutIconSvg),
  SearchHereIconSvg: React.lazy(SearchHereIconSvg),
  SearchZoomIconSvg: React.lazy(SearchZoomIconSvg),
  SegmentBirdingSvg: React.lazy(SegmentBirdingSvg),
  SegmentOutdoorSvg: React.lazy(SegmentOutdoorSvg),
  SegmentHuntingSvg: React.lazy(SegmentHuntingSvg),
  SegmentBirdingTrimmedSvg: React.lazy(SegmentBirdingTrimmedSvg),
  SegmentOutdoorTrimmedSvg: React.lazy(SegmentOutdoorTrimmedSvg),
  SegmentHuntingTrimmedSvg: React.lazy(SegmentHuntingTrimmedSvg),
  IconMyLocationSvg: React.lazy(IconMyLocationSvg),
  PhoneIconSvg: React.lazy(PhoneIconSvg),
  MailIconSvg: React.lazy(MailIconSvg),
  NavigateIconSvg: React.lazy(NavigateIconSvg),
  PinWhiteSvgIcon: React.lazy(PingWhiteSvgIcon),
  AccountBlackSvgIcon: React.lazy(AccountBlackSvgIcon),
};

export type DealerLocatorIconT = keyof typeof Icons;

export const DealerLocatorIcons: ReactTFC<{
  icon: DealerLocatorIconT;
  className?: string;
  fallback?: NonNullable<ReactNode> | null;
}> = props => {
  const { icon, fallback, ...rest } = props;
  const env = useEnvironment();

  const fallbackOrNull: NonNullable<ReactNode> | null = fallback || null;

  if (env === "server") {
    return <React.Fragment>{fallbackOrNull}</React.Fragment>;
  }

  const Component = Icons[icon];

  return (
    <React.Suspense fallback={fallbackOrNull}>
      <Component {...rest} />
    </React.Suspense>
  );
};
